/* eslint-disable no-useless-escape */
import Script from 'next/script'

import { CookieConsentStatus } from 'constants/localStorage'
import { useCookieConsent } from 'providers/CookieConsentProvider'
import { isGoogleAnalyticsEnabled } from 'utils/analytics'

/**
 * Third party scripts that don't support Google Consent Mode, so they are
 * only loaded after the user accepts cookies. Google Tag Manager can contain
 * non Google tags, which would otherwise ignore the consent choice.
 */
export const ConsentedTrackingScripts = () => {
  const { consentStatus } = useCookieConsent()

  if (
    !isGoogleAnalyticsEnabled ||
    consentStatus !== CookieConsentStatus.Granted
  ) {
    return null
  }

  return (
    <>
      {/* GOOGLE TAG MANAGER */}
      <Script
        id="gtm-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-P5LL5H3');
      `,
        }}
      />
      <Script
        id="sopro-plugin"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
        (function (o, u, t, b, a, s, e) {
          window[b] = window[b] || {}; (e = e || [])['key'] = o; e['__obr'] = u.location.href; a = [];
          u.location.search.replace('?', '').split('&').forEach(function (q) { if (q.startsWith(b) || q.startsWith('_obid')) e[q.split('=')[0]] = q.split('=')[1]; });
          e['_obid'] = e['_obid'] || (u.cookie.match(/(^|;)\s*_obid\s*=\s*([^;]+)/) || []).pop() || 0;
          for (k in e) { if (e.hasOwnProperty(k)) a.push(encodeURIComponent(k) + '=' + encodeURIComponent(e[k])); }
          s = u.createElement('script'); s.src = t + '?' + a.join('&'); u.head.appendChild(s);
      })('b84d93aa-9622-4246-a065-77148c90b2ec', document, 'https://plugin.sopro.io/hq.js', 'outbase');
      `,
        }}
      />
    </>
  )
}
